export const CANVAS_HEADER_ACTIONS_ID = "canvas-header-actions";
export const canvasHeaderActionsSelector = `#${CANVAS_HEADER_ACTIONS_ID}`;

export const CANVAS_HEADER_LEFT_ACTIONS_ID = "canvas-header-left-actions";
export const canvasHeaderLeftActionsSelector = `#${CANVAS_HEADER_LEFT_ACTIONS_ID}`;

export const CANVAS_HEADER_TITLE_ACTIONS_ID = "canvas-header-title-actions";
export const canvasHeaderTitleActionsSelector = `#${CANVAS_HEADER_TITLE_ACTIONS_ID}`;

export const CANVAS_MOBILE_HEADER_LEFT_ACTIONS_ID =
  "canvas-mobile-header-left-actions";
export const canvasMobileHeaderLeftActionsSelector = `#${CANVAS_MOBILE_HEADER_LEFT_ACTIONS_ID}`;

export const CANVAS_MOBILE_HEADER_TITLE_ACTIONS_ID =
  "canvas-mobile-header-title-actions";
export const canvasMobileHeaderTitleActionsSelector = `#${CANVAS_MOBILE_HEADER_TITLE_ACTIONS_ID}`;

export const CANVAS_MOBILE_HEADER_ACTIONS_ID = "canvas-mobile-header-actions";
export const canvasMobileHeaderActionsSelector = `#${CANVAS_MOBILE_HEADER_ACTIONS_ID}`;

export const CANVAS_MOBILE_SETTINGS_HEADER_ACTIONS_ID =
  "canvas-mobile-settings-header-actions";
export const canvasMobileSettingsHeaderActionsSelector = `#${CANVAS_MOBILE_SETTINGS_HEADER_ACTIONS_ID}`;
